<template>
  <div class="finantial-settings-accounts-question">
    <i class="finantial-settings-accounts-question__icon icon-suitcase" />
    <div
      class="finantial-settings-accounts-question__text"
      v-text="text"
    />
    <div class="finantial-settings-accounts-question__button finantial-settings-accounts-question__button--add">
      <el-button
        type="secondary"
        icon="icon-add"
        :disabled="loadingConnectedAccount"
        @click="onAdd"
      >
        <app-i18n code="common.yes" />
      </el-button>
    </div>
    <div class="finantial-settings-accounts-question__button finantial-settings-accounts-question__button--nope">
      <el-button
        type="primary"
        icon="icon-accept"
        :disabled="loadingConnectedAccount"
        :loading="isLoading"
        @click="onNope"
      >
        <app-i18n code="common.no" />
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@shared/i18n';

export default {
  name: 'finantial-settings-accounts-question',
  props: {
    code: String,
    connectedAccountName: String,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      loadingConnectedAccount: 'paymentSettings/loadingConnectedAccount',
    }),
    text({ code, connectedAccountName }) {
      return i18n(`subpropertySettings.finantial.questions.${code}`, connectedAccountName)
    },
    params({ code }) {
      switch (code) {
        case 'relationship.owner': return { isOwner: true }
        case 'relationship.director': return { isDirector: true }
        case 'relationship.executive': return { isExecutive: true }
        default: return {}
      }
    },
  },
  methods: {
    onAdd() {
      this.$emit('add', this.params)
    },
    onNope() {
      this.$emit('nope', this.params)
      this.isLoading = true
    },
  },
}
</script>

<style lang="scss" scoped>
.finantial-settings-accounts-question {
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  grid-template-columns: auto 1fr auto auto;
  grid-gap: 16px;
  margin: 24px 16px;

  &__icon {
    color: rgba(102, 102, 102, 0.74);
  }

  &__text {
    font-size: 14px;
    letter-spacing: 0.2px;
    color: rgba(102, 102, 102, 0.74);
  }
}
</style>
